import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { request } from '@core/api/request';
import { QUERY_KEYS } from '@shared/constants/query-keys';

export type TTimezone = {
  name?: string;
};

export const getAllTimezones = async (options?: {
  query?: TTimezone;
}): Promise<string[]> => {
  return request({
    url: `locales/timezones/`,
    params: options?.query,
  });
};

export const useGetAllTimezones = (
  query?: TTimezone,
  options?: Partial<UseQueryOptions<string[]>>
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.getTimezones, query],
    queryFn: async () => await getAllTimezones({ query }),
    staleTime: 60000,
    ...options,
  });
};
